import { getPath } from 'app/api/api';
import { reduce } from 'lodash-es';
import { ExplorerEntityMeta, ExplorerEntityTypes } from 'entities/types';
import { useEffect, useState } from 'react';

export const useEntityPath = (currentEntity: ExplorerEntityMeta | null) => {
  const [meta, setMeta] = useState<null | ExplorerEntityMeta[]>(null);

  const id = currentEntity?.id || null;
  const type = currentEntity?.type || null;
  const name = currentEntity?.name || '';

  useEffect(() => {
    const initPath = async () => {
      if (id && type) {
        // Костыль для секций
        if (type === ExplorerEntityTypes.SECTION) {
          setMeta([{ id, type, name }]);

          return;
        }

        try {
          const path = await getPath({ id, type });
          setMeta(path);
        } catch (e) {
          console.error(e);
        }
      }
    };

    initPath();
  }, [id, type, name]);

  if (meta) {
    let sectionMeta: ExplorerEntityMeta | null = null;
    let fileOrTableMeta: ExplorerEntityMeta | null = null;
    let foldersMeta: ExplorerEntityMeta[] | null = null;

    if (meta.at(0)?.type === ExplorerEntityTypes.SECTION) {
      sectionMeta = meta[0];
    }

    if (
      meta.at(-1)?.type === ExplorerEntityTypes.FILE ||
      meta.at(-1)?.type === ExplorerEntityTypes.TABLE
    ) {
      fileOrTableMeta = meta.at(-1)!;
    }

    const names = reduce(
      meta,
      (acc: ExplorerEntityMeta[], item) => {
        if (item.type === ExplorerEntityTypes.FOLDER) {
          acc.push(item);
        }
        return acc;
      },
      []
    );

    if (names.length) {
      foldersMeta = names;
    }

    return {
      meta,
      sectionMeta,
      fileOrTableMeta,
      foldersMeta,
    };
  }

  return {
    meta,
    sectionMeta: null,
    fileOrTableMeta: null,
    foldersMeta: null,
  };
};
